import { ThreadReadStatus } from '@weave/schema-gen-ts/dist/schemas/sms/data/v4/sms_service.pb';
import { Direction, Status } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { Thread } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { KnownThreadStatus } from '../../../types';

/**
 * Returns the possible ThreadReadStatus values that this thread matches. If `undefined` is returned, it means that the
 * ThreadReadStatus cannot be determined from the thread, and should be based on its previous status.
 */
export const convertSMSStatusToPossibleThreadReadStatuses = (thread: Thread): ThreadReadStatus[] | undefined => {
  if (!thread.messages.length) {
    return undefined;
  }

  const result: ThreadReadStatus[] = [];

  const newestMessage = thread.messages[0]!;
  const resolvedIsReplied =
    thread.isReplied || (newestMessage.direction === Direction.DIRECTION_OUTBOUND && !newestMessage.autogeneratedBy);
  const resolvedIsUnreplied =
    thread.isReplied === undefined ? newestMessage.direction === Direction.DIRECTION_INBOUND : !thread.isReplied;

  if (newestMessage.status === Status.STATUS_ERROR || thread.status === KnownThreadStatus.ERROR) {
    result.push(ThreadReadStatus.ERROR);
  }
  if (thread.status === KnownThreadStatus.NEW) result.push(ThreadReadStatus.NEW);
  if (thread.status === KnownThreadStatus.READ) result.push(ThreadReadStatus.READ);
  if (resolvedIsReplied) result.push(ThreadReadStatus.REPLIED);
  if (resolvedIsUnreplied) result.push(ThreadReadStatus.UNREPLIED);

  if (!result.length) return undefined;
  return result;
};
